import { useState, useEffect } from 'react';
import API from '@/lib/api';
import { Paperclip, Trash, UploadSimple, File, FilePdf, FileImage } from '@phosphor-icons/react';

const ICON_MAP = {
  pdf: FilePdf, png: FileImage, jpg: FileImage, jpeg: FileImage, gif: FileImage,
};

export default function BijlagenPanel({ docId }) {
  const [bijlagen, setBijlagen] = useState([]);
  const [uploading, setUploading] = useState(false);

  const load = () => {
    if (!docId) return;
    API.get(`/bijlagen?doc_id=${docId}`).then(r => setBijlagen(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, [docId]);

  const upload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      fd.append('doc_id', docId || '');
      await API.post('/bijlagen/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      load();
    } catch (err) {
      alert(err.response?.data?.detail || 'Upload mislukt');
    }
    setUploading(false);
    e.target.value = '';
  };

  const del = async (id) => {
    if (!window.confirm('Bijlage verwijderen?')) return;
    await API.delete(`/bijlagen/${id}`);
    load();
  };

  const fileUrl = (b) => `${process.env.REACT_APP_BACKEND_URL}/api/bijlagen/${b.id}/download`;

  const fmtSize = (bytes) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  if (!docId) return null;

  return (
    <div data-testid="bijlagen-panel">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-bold uppercase tracking-wider text-gray-400 flex items-center gap-1.5">
          <Paperclip size={14} /> Bijlagen ({bijlagen.length})
        </span>
        <label className="btn btn-ghost btn-sm cursor-pointer" data-testid="upload-bijlage-btn">
          <UploadSimple size={13} /> {uploading ? 'Bezig...' : 'Upload'}
          <input type="file" className="hidden" onChange={upload} disabled={uploading}
            accept=".pdf,.png,.jpg,.jpeg,.gif,.doc,.docx,.xls,.xlsx,.csv,.txt" />
        </label>
      </div>

      {bijlagen.length > 0 && (
        <div className="space-y-1">
          {bijlagen.map(b => {
            const Icon = ICON_MAP[b.type] || File;
            return (
              <div key={b.id} className="flex items-center gap-2 px-2 py-1.5 bg-gray-50 border border-gray-100 text-xs">
                <Icon size={16} className="text-[#002FA7] shrink-0" />
                <a href={fileUrl(b)} target="_blank" rel="noopener noreferrer"
                  className="flex-1 truncate text-[#002FA7] hover:underline font-medium" data-testid={`bijlage-${b.id}`}>
                  {b.filename}
                </a>
                <span className="text-gray-400 shrink-0">{fmtSize(b.size)}</span>
                <button className="text-red-400 hover:text-red-600 shrink-0" onClick={() => del(b.id)} data-testid={`del-bijlage-${b.id}`}>
                  <Trash size={12} />
                </button>
              </div>
            );
          })}
        </div>
      )}

      {bijlagen.length === 0 && (
        <div className="text-[10px] text-gray-300 text-center py-2">Geen bijlagen</div>
      )}
    </div>
  );
}
